module.exports = "<template> <sio-form config.bind=formConfiguration submit.call=submitInternal(object)></sio-form> </template> ";